import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { CREDENTIALS } from "../../data/site";

const PORTRAIT =
  "https://images.unsplash.com/photo-1573497019236-17f8177b81e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxmcmllbmRseSUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0JTIwd29tYW58ZW58MHx8fHwxNzg2Njk5ODcwfDA&ixlib=rb-4.1.0&q=85";

export const Trust = () => (
  <section id="trust" data-testid="trust-section" className="py-28 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-14 items-center">
      <Reveal className="md:col-span-5">
        <div className="relative">
          <div className="rounded-[2rem] overflow-hidden border border-[#D5D1C8] aspect-[4/5]">
            <img src={PORTRAIT} alt="Friendly, vetted home assistant" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-4 md:right-6 bg-[#C26D5C] text-[#F9F8F6] rounded-2xl px-6 py-5 max-w-[200px]">
            <p className="font-serif text-2xl leading-tight">Vetted, insured & genuinely kind</p>
          </div>
        </div>
      </Reveal>

      <div className="md:col-span-7">
        <Reveal>
          <p className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#C26D5C] mb-6">People you can trust</p>
          <h2 className="font-serif font-light text-5xl md:text-6xl text-[#1A362D] tracking-tight leading-[1.05] max-w-xl">
            Reliable independent contractors, thoroughly checked.
          </h2>
          <p className="mt-6 text-lg text-[#4A5A53] leading-relaxed max-w-lg">
            Every home assistant on our team chooses the jobs and hours that suit them — and holds the
            credentials that let you welcome them into your home with confidence.
          </p>
        </Reveal>

        <div className="mt-10 grid sm:grid-cols-2 gap-4">
          {CREDENTIALS.map((c, i) => (
            <Reveal key={c} delay={i * 0.05}>
              <motion.div
                whileHover={{ y: -4 }}
                className="flex items-center gap-4 p-5 rounded-2xl border border-[#D5D1C8] bg-[#EAE6DF]"
              >
                <span className="shrink-0 w-11 h-11 rounded-full bg-[#D1DEC9] flex items-center justify-center">
                  <ShieldCheck size={20} className="text-[#1A362D]" />
                </span>
                <span className="font-medium text-[#1A362D]">{c}</span>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
